// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-colour-palette_container__H3skS","primary":"business-resource-colour-palette_primary__0ekr_"};